var map = {
	"./PBR/preset_back.png": 8170,
	"./PBR/preset_back_withoutNormal.png": 4554,
	"./PBR/preset_front.png": 2414,
	"./PBR/preset_front_withoutNormal.png": 2910,
	"./PBR/roughness0.5metalic0.5.png": 6082,
	"./PBR/roughness0.5metalic0.5withAO.png": 9770,
	"./PBR/roughness0metalic0.png": 3806,
	"./PBR/roughness0metalic1.png": 9383,
	"./PBR/roughness1metalic0.png": 9867,
	"./PBR/roughness1metalic1.png": 4514,
	"./RayTracing/all.png": 7778,
	"./RayTracing/capsule_tex.png": 4256,
	"./RayTracing/multiple.png": 7223,
	"./RayTracing/reflection2.png": 8092,
	"./RayTracing/reflection3.png": 9717,
	"./ResumeSaver/Snipaste_2025-03-29_03-35-18.png": 2141,
	"./ResumeSaver/Snipaste_2025-03-29_03-36-46.png": 4809,
	"./ResumeSaver/Snipaste_2025-03-29_03-37-07.png": 7891,
	"./ResumeSaver/Snipaste_2025-03-29_03-50-00.png": 4835,
	"./ResumeSaver/Snipaste_2025-03-29_03-57-47.png": 2533,
	"./ResumeSaver/Snipaste_2025-03-29_03-58-01.png": 3906,
	"./ResumeSaver/Snipaste_2025-03-29_04-01-54.png": 8341,
	"./ResumeSaver/Snipaste_2025-03-29_04-02-13.png": 7424,
	"./ResumeSaver/Snipaste_2025-03-29_04-03-21.png": 9087,
	"./Shader/Effect.png": 3159,
	"./Shader/Model.png": 2733,
	"./Shader/ork.png": 4948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4288;